import { makeEventListener } from '@solid-primitives/event-listener';
import { createHydratableSingletonRoot } from '@solid-primitives/rootless';
import { noop, trueFn, createHydratableSignal } from '@solid-primitives/utils';
import { isServer } from 'solid-js/web';

// src/index.ts
function makeConnectivityListener(callback) {
  if (isServer) {
    return noop;
  }
  const clear1 = makeEventListener(window, "online", callback.bind(void 0, true));
  const clear2 = makeEventListener(window, "offline", callback.bind(void 0, false));
  return () => {
    clear1();
    clear2();
  };
}
function createConnectivitySignal() {
  if (isServer) {
    return trueFn;
  }
  const [status, setStatus] = createHydratableSignal(true, () => navigator.onLine);
  makeConnectivityListener(setStatus);
  return status;
}
var useConnectivitySignal = /* @__PURE__ */ createHydratableSingletonRoot(createConnectivitySignal);

export { createConnectivitySignal, makeConnectivityListener, useConnectivitySignal };
